<template>
     <div class="main_content" style="width:90%">
        <div class="c-title" style="text-align:center;">隐私政策</div>
        <p>尊敬的用户：</p>
        <p style="text-indent: 2em;">1、尊重与保护用户个人信息是本服务的一项基本原则。</p>
        <p style="text-indent: 2em;">2、本业务需采集用户的个人信息包括：手机号码、IP地址。</p>
        <p style="text-indent: 2em;">3、用户同意本服务基于以下事项使用用户的个人信息：</p>
        <p style="text-indent: 2em;">（1）读取、上传、记录用户个人信息数据并进行同步、分享和储存以实现部分服务功能；</p>
        <p style="text-indent: 2em;">（2）收集用户个人信息数据并统计、分析及研究，以改进本服务的质量；</p>
        <p style="text-indent: 2em;">（3）改进或提高用户的使用安全性和服务性；</p>
        <p style="text-indent: 2em;">（4）向用户发送本服务的重要通知和服务信息；</p>
        <p style="text-indent: 2em;">（5）适用法律法规规定的其他事项。 （可根据应用实际情况修改补充）除上述事项外，如未取得用户事先同意，本应用不会将用户个人信息使用于任何其他用途。</p>
        <p style="text-indent: 2em;">4、本服务采取技术措施和其他必要措施，确保用户个人信息安全，防止在本服务中收集的用户个人信息泄露、毁损或丢失。</p>
        <p style="text-indent: 2em;">5、本服务承诺未经用户同意不向任何第三方公开、透露用户个人信息，但法律法规规定或有权机关的指示提供用户的个人信息除外。</p>

    </div>
</template>

<script>
import 'common/css/reset.css';

export default {
    name: 'result1',
    components: {
        
    },
    created(){
        
    },
    data(){
        return {
        };
    },
    mounted(){
       
    },
    methods:{
        

    }
}
</script>

<style scoped>
    body {
        height: 100%;
        min-width: 320px;
        background: #FE7C5C;
    }

    div {
        margin: 0;
        padding: 0;
    }

    .main_content {
    width: 80%;
    padding: 1rem;
    margin: 0.5rem auto;
    border-radius: 0.5rem;
    background-color: #fff;
}

.c-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    display: flex;
    align-items: center;
}

.main_content p {
    line-height: 150%;
    font-size: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// ResultApp1.vue?958d70f8